<template>
  <div class="product-block" :class="`product-block--${modifier}`">
    <div class="click-layer">
      <slot name="rank"></slot>
      <div class="imageBlock">
        <a v-bind:href="info.tp_url" target="_blank">
          <img v-if="!error && (info.tp_pic)" :src="info.tp_pic" @error="handleImgErr"/>
        </a>
      </div>
      <a v-bind:href="info.tp_url" target="_blank"><h2 style="height: 35px;">{{ info.tp_name }}</h2></a>
    </div>
    <div class="block-bottom">
      <div>
        <span v-if="info.tp_original_price != ''" class="originPrice" style="display: block; color: #aaaaaa; font-size: 10px; text-decoration: line-through;">
          ${{info.tp_original_price}}
        </span>
        <span
          v-if="info.tp_market_style === 'Y'"
          class="price">
            <img src="../assets/img/icon/pi-point.svg" width="11px;" height="11px;" style="margin-right: 2px;"/>{{info.tp_price}}
        </span>
        <span
          v-else
          class="price">${{info.tp_price }}
        </span>
      </div>
      <div class="promo-label" :class="{ fill: info.tp_market_style === 'Y' }">
          <span class="points" v-if="info.tp_market_style === 'Y'">{{ info.tp_market_content }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const modifierType = { s: 's', m: 'm', l: 'l' }
export default {
  name: 'ProductBlock',
  props: {
    info: {
      tp_url: String,
      tp_pic: String,
      tp_market_style: String,
      tp_market_content: String,
      tp_name: String,
      subTitle: String,
      tp_price: String,
      tp_original_price: String
    },
    modifier: String,
  },
  data: function() {
    return {
      modifierType,
      error: false
    }
  },
  computed: {},
  methods: {
    handleImgErr() {
      this.error = true
    },
  },
}
</script>

<style scoped lang="scss">
h2 {
  width: 95%;
  font-size: 12px;
  color: #545454;
  line-height: 1.5;
  margin-bottom: 4px;
  font-weight: 500;
  overflow: hidden;
  max-height: 40px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 6px;
}
h3 {
  font-size: 13px;
  color: #4a4a4a;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight: normal;
  height: 38px;
}
.price {
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1da7fc;
  display: block;
  margin-top: -4px;
  ~ span {
    color: #aaaaaa;
    margin-left: 6px;
    font-size: 10px;
    text-decoration: line-through;
  }
  .points {
    font-size: 0;
    width: 16px;
    vertical-align: middle;
    img {
      width: 100%;
    }
  }
}
.product-block--l {
  h2 {
    font-size: 16px;
    max-height: 48px;
    line-height: 24px;
    color: #383838;
  }
  h3 {
    font-size: 12px;
    max-height: 48px;
    height: auto;
    color: #545454;
  }
}
.product-block--s h2,
.product-block--m h2 {
  margin-bottom: 2px;
}
.product-block--s {
  font-size: 16px;
  .price {
    font-size: 14px;
  }
}

.imageBlock {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
  background: url('../assets/img/placholder_512.svg');
  background-size: contain;
  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}

.promo-label {
  border-radius: 9px;
  font-size: 10px;
  font-weight: 500;
  color: #1da7fc;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 5%;
  transform: scale(0.9);
  &.fill {
    background-color: #1da7fc;
    color: #ffffff;
    position: absolute;
    width: 33px;
    right: 0px;
    bottom: 3px;
  }
  .points {
    font-size: 9px;
    display: inline-block;
    width: 9px;
    img {
      width: 100%;
    }
  }
}

.sold-out-img {
  filter: grayscale(1) opacity(0.5);
  position: relative;
}

.sold-out-tip {
  position: absolute;
  left: 0;
  bottom: 8px;
  display: flex;
  font-size: 13px !important;
  width: 50px;
  height: 22px;
  text-align: center;
  color: #ffffff;
  background-color: #000000e5;
  border-top-right-radius: 8px;
  z-index: 9;
  justify-content: center;
  align-items: center;
}

.sold-out-price {
  color: #9b9b9b;
}

.block-bottom {
  position: relative;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row wrap;
  margin-top: 5px;
  .block-bottom-left {
    display: flex;
    flex-flow: column;
  }
  .favorite {
    width: 24px;
    height: 24px;
    .v-icon {
      width: 24px;
      height: 24px;
      font-size: 19px;
      color: #fe585c;
    }
  }
}
</style>
